import React, { FC } from "react";
import { makeStyles } from "@material-ui/styles";

import { TheCycleverseTheme } from "../theme";

type CycleverseDividerProps = { marginTop?: number; marginBottom?: number };

const useStyles = makeStyles((theme: TheCycleverseTheme) => ({
  root: {
    height: 1,
    // NOTE: this is the fallback for old browsers if the next one
    // doesn't make sense to them
    background: theme.highlightGradientBg,
    // eslint-disable-next-line no-dupe-keys
    // @ts-ignore
    background: theme.highlightGradient,
    marginTop: (props: CycleverseDividerProps) => (props.marginTop ? theme.spacing(props.marginTop) : null),
    marginBottom: (props: CycleverseDividerProps) => (props.marginBottom ? theme.spacing(props.marginBottom) : null),
  },
}));

const CycleverseDivider: FC<CycleverseDividerProps> = (props) => {
  const classes = useStyles(props);
  return <div className={classes.root} />;
};

export default CycleverseDivider;
